module.exports = __webpack_public_path__ + "static/element-icons.732389d.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/theme-chalk/fonts/element-icons.ttf
// module id = 226
// module chunks = 1